<template>
    <section>
        <div class="p-6 px-8">
            <div class="relative">
                <info-box :message="getWelcomeMessage()"></info-box>
            </div>
        </div>
    </section>
</template>

<script>
import { SupportIcon, XIcon } from "@heroicons/vue/outline";
import InfoBox from "../components/InfoBox.vue";

export default {
    components: {
        SupportIcon,
        XIcon,
        InfoBox,
    },
    mounted() {
        Eventing.fire("checkAuthStatus");
        Eventing.listen("checkNextMeeting", () =>
            this.checkForNextMeeting(false)
        );
        Eventing.listen("toggleProxy", () => this.resetVotingWeight());
    },
    data() {
        return {
            message: null, ///<b>Welkom op Online-ALV.nl</b><br>Momenteel staan er geen vergaderingen gepland.",
            user: {
                email: null,
                name: null,
                phone: null,
            },
            loading: false,
            next_meeting: null,
        };
    },
    created() {
        try {
            this.user = {
                email: document.head.querySelector('meta[name="email"]')
                    .content,
                name: document.head.querySelector('meta[name="name"]').content,
                phone: document.head.querySelector('meta[name="phone"]')
                    .content,
                hide_2fa:
                    document.head.querySelector('meta[name="hide_2fa"]')
                        .content == "true"
                        ? true
                        : false,
                is_moderator:
                    document.head.querySelector('meta[name="is_moderator"]')
                        .content == "true"
                        ? true
                        : false,
            };
        } catch (error) {
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }

        try {
            if (this.next_meeting) {
                if (this.next_meeting == "new") {
                    this.checkForNextMeeting(true);
                } else {
                    if (localStorage.getItem('redirect-to-live') === 'yes') {

                        this.$router.push({
                            name: "live",
                            params: { slug: this.next_meeting },
                        });
                    } else {
                        this.$router.push({
                            name: "room",
                            params: { slug: this.next_meeting },
                        });
                    }
                }
            } else if (
                document.head.querySelector('meta[name="next_meeting"]')
            ) {
                this.next_meeting = document.head.querySelector(
                    'meta[name="next_meeting"]'
                ).content;
                if (this.next_meeting && !this.user.is_moderator) {
                    if (localStorage.getItem('redirect-to-live') === 'yes') {

                        this.$router.push({
                            name: "live",
                            params: { slug: this.next_meeting },
                        });
                    } else {
                        this.$router.push({
                            name: "room",
                            params: { slug: this.next_meeting },
                        });
                    }
                } else {
                    this.checkForNextMeeting(true);
                }
            } else {
                this.checkForNextMeeting(true);
            }
        } catch (error) {
            // this.checkForNextMeeting(true);
        }
    },
    methods: {
        getWelcomeMessage() {
            return this.t(
                "dashboard.no-meetings-planned",
                "Momenteel staan er geen vergaderingen gepland."
            );
        },
        resetVotingWeight() {
            try {
                document.head.querySelector(
                    'meta[name="voting_weight"]'
                ).content = 0;
            } catch (error) {
                window.location.reload();
            }
        },
        checkForNextMeeting(redirect) {
            this.next_meeting = "new";
            let message = this.message;
            this.message = null;
            try {
                axios
                    .get("/api/meetings?next-meeting=true")
                    .then((response) => {
                        this.next_meeting = response.data.data.hash;
                        if (redirect) {
                            if (localStorage.getItem('redirect-to-live') === 'yes') {
        
                                this.$router.push({
                                    name: "live",
                                    params: { slug: this.next_meeting },
                                });
                            } else {
                                this.$router.push({
                                    name: "room",
                                    params: { slug: this.next_meeting },
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        // this.message = message;
                        // window.location.href = "/";
                    });
            } catch (error) {
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            }
        },
    },
};
</script>
